import getRouterBasename from '@/lib/router';
import { Navigate, createBrowserRouter } from 'react-router-dom';

import AccessDenied from 'pages/AccessDenied';
import Admin from 'pages/Admin';
import Artifacts from 'pages/Artifacts';
import AuthCallback from 'pages/AuthCallback';
import DMOrganizationThreads from 'pages/DMOranizationThreads';
import DashboardView from 'pages/DashboardView';
import Element from 'pages/Element';
import Env from 'pages/Env';
import FilePreview from 'pages/FilePreview';
import Home from 'pages/Home';
import Login from 'pages/Login';
import OrganizationArtifacts from 'pages/OrganizationArtifacts';
import Organizations from 'pages/Organizations';
import Page from 'pages/Page';
import AgentBank from 'pages/ScheduledAgents/AgentBank';
import Article from 'pages/ScheduledAgents/Article';
import ManageAgent from 'pages/ScheduledAgents/ManageAgent';
import ScheduledAgentSetup from 'pages/ScheduledAgents/ScheduledAgentSetup';
import StreamAnalysis from 'pages/ScheduledAgents/StreamAnalysis';
import Thread from 'pages/Thread';
import UnderUpdate from 'pages/UnderUpdate';

import { ScheduledAgentsPageTransition } from '@/components/ScheduledAgents/ScheduledAgentsPageTransition';
import { SharedThread } from '@/components/SharedThread';
import { RequireAdmin } from '@/components/auth/RequireAdmin';

export const router: ReturnType<typeof createBrowserRouter> =
    createBrowserRouter(
        [
            {
                path: '/maintenance',
                element: <UnderUpdate />
            },
            {
                path: '/access-denied',
                element: <AccessDenied />
            },
            {
                path: '/',
                element: <Page />,
                children: [
                    {
                        index: true,
                        element: <Home />
                    },
                    {
                        path: 'admin',
                        element: (
                            <RequireAdmin>
                                <Admin />
                            </RequireAdmin>
                        )
                    },
                    {
                        path: 'env',
                        element: <Env />
                    },
                    {
                        path: 'thread/:id?',
                        element: <Thread />
                    },
                    {
                        path: '/thread-shared/:token',
                        element: <SharedThread />
                    },
                    {
                        path: 'element/:id',
                        element: <Element />
                    },
                    {
                        path: 'organizations',
                        element: <Organizations />
                    },
                    {
                        path: 'artifacts/:id?',
                        element: <Artifacts />
                    },
                    {
                        path: 'organization-artifacts/:id?',
                        element: <OrganizationArtifacts />
                    },
                    {
                        path: 'organization-threads',
                        element: <DMOrganizationThreads />
                    },
                    {
                        path: 'scheduled-jobs',
                        element: <ScheduledAgentsPageTransition />,
                        children: [
                            {
                                index: true,
                                element: <StreamAnalysis />
                            },
                            {
                                path: 'bank',
                                element: <AgentBank />
                            },
                            {
                                path: 'new',
                                element: <ScheduledAgentSetup />
                            },
                            {
                                path: 'manage/:id',
                                element: <ManageAgent />
                            },
                            {
                                path: 'stream/:agentId',
                                element: <StreamAnalysis />
                            },
                            {
                                path: 'article/:briefId',
                                element: <Article />
                            }
                        ]
                    }
                ]
            },
            {
                path: '/login',
                element: <Login />
            },
            {
                path: '/login/callback',
                element: <AuthCallback />
            },
            {
                path: '/dashboard/:id',
                element: <DashboardView />
            },
            {
                path: '/dashboard/:id/published',
                element: <DashboardView published />
            },
            {
                path: '/file-preview',
                element: <FilePreview />
            },
            {
                path: '*',
                element: <Navigate replace to="/" />
            }
        ],
        { basename: getRouterBasename() }
    );
